/**
 * cross section overlay for 2d
 */
import _ from "underscore";
import µ from "../../earth/1.0.0/micro";
import mcGeometry from "./mc-geometry"
import mcText from "./mc-overlay-text"
import * as THREE from "three";

export default (function(canvas, configuration) {
    var parentView = µ.view();
    var container = canvas;

    const right = container.width / 2;
    // const top = container.height / 2;
    const initScale = right * 0.8;

    var renderer, scene, camera;
    var overlayGeometry, overlayMaterial, overlayMesh;
    var pressureLineGeometry, pressureLineMaterial, pressureLineMesh;
    var crossSectionContourGeometry, crossSectionContourMaterial, invalidCrossSectionContourMaterial, crossSectionContourMesh, invalidCrossSectionContourMesh;
    // var log = µ.log();

    var pressureLabel;

    function checkWebGL(canvas){
        let gl;

        try {
            gl = canvas.node().getContext("webgl");
        } catch (e) {}

        if (!gl) {
            try {
                gl = canvas.node().getContext("experimental-webgl");
            } catch (e) {}
        }

        return gl || undefined;
    }

    function pixelRatio(){
        let context = checkWebGL(container);
        let devicePixelRatio = window["devicePixelRatio"] || 1,
            backingStoreRatio = context.webkitBackingStorePixelRatio ||
                context.mozBackingStorePixelRatio ||
                context.msBackingStorePixelRatio ||
                context.oBackingStorePixelRatio ||
                context.backingStorePixelRatio || 1;
        return devicePixelRatio / backingStoreRatio;
    }

    // function clearColor(){
    // 	let gl = checkWebGL(container);

    //     if(gl){
    //         gl.clear(gl.DEPTH_BUFFER_BIT | gl.COLOR_BUFFER_BIT);
    // 		gl.clearColor(0, 0, 0, 0);
    // 	}
    // }

    function rendered(){
        return renderer !== undefined;
    }

    function clearMeshes(){
        if(overlayGeometry) overlayGeometry.dispose();
        if(overlayMaterial) {
            overlayMaterial.dispose();
        }

        overlayGeometry = undefined;
        overlayMaterial = undefined;
        overlayMesh = undefined;

        if(pressureLineGeometry) pressureLineGeometry.dispose();
        if(pressureLineMaterial) pressureLineMaterial.dispose();

        pressureLineGeometry = undefined;
        pressureLineMaterial = undefined;
        pressureLineMesh = undefined;

        if(pressureLabel) pressureLabel.clear();
        pressureLabel = undefined;

        if(crossSectionContourGeometry) crossSectionContourGeometry.dispose();
        if(crossSectionContourMaterial) crossSectionContourMaterial.dispose();

        crossSectionContourGeometry = undefined;
        crossSectionContourMaterial = undefined;
        crossSectionContourMesh = undefined;
        invalidCrossSectionContourMesh = undefined;

        if(scene && scene.children && scene.children.length > 0){
            while(scene.children.length > 0){
                scene.remove(scene.children[0]);
            }
        }

        if(renderer){
            renderer.clear();
        }
    }

    function clearResource(){
        if(renderer){
            renderer.setAnimationLoop(null);
        }

        if(renderer){
            renderer.clear();
        }

        if(overlayGeometry) overlayGeometry.dispose();
        if(overlayMaterial) {
            overlayMaterial.dispose();
        }

        overlayGeometry = undefined;
        overlayMaterial = undefined;
        overlayMesh = undefined;

        if(pressureLineGeometry) pressureLineGeometry.dispose();
        if(pressureLineMaterial) pressureLineMaterial.dispose();

        pressureLineGeometry = undefined;
        pressureLineMaterial = undefined;
        pressureLineMesh = undefined;

        if(pressureLabel) pressureLabel.clear();
        pressureLabel = undefined;

        if(crossSectionContourGeometry) crossSectionContourGeometry.dispose();
        if(crossSectionContourMaterial) crossSectionContourMaterial.dispose();

        crossSectionContourGeometry = undefined;
        crossSectionContourMaterial = undefined;
        crossSectionContourMesh = undefined;
        invalidCrossSectionContourMesh = undefined;

        if(scene && scene.children && scene.children.length > 0){
            while(scene.children.length > 0){
                scene.remove(scene.children[0]);
            }
        }

        if(scene){
            scene.dispose();
            scene = undefined;
        }

        if(camera){
            // 	camera.dispose();
            camera = undefined;
        }

        if(renderer){
            renderer.dispose();
            renderer = undefined;
        }

    }

    function meshPressureLineMaterial(crossSectionData){
        pressureLineGeometry = mcGeometry.crossSectionPressureLineGeometry(crossSectionData.coords, crossSectionData.data, crossSectionData.pressures, initScale);
        pressureLineMaterial = new THREE.LineDashedMaterial( {
            transparent: true,
            color: 0xD0D0D0,
            linewidth: 1,
            scale: 1,
            dashSize: 3,
            gapSize: 1,
            opacity: 0.3,
        } );

        pressureLineMesh = new THREE.LineSegments(pressureLineGeometry, pressureLineMaterial);
        pressureLineMesh.computeLineDistances();

        scene.add(pressureLineMesh);
    }

    function meshOverlayMaterial(crossSectionData, scale, binaryScale){
        overlayGeometry = mcGeometry.crossSectionGeometry(crossSectionData.coords, crossSectionData.data, crossSectionData.pressures, initScale, scale, binaryScale);
        overlayMaterial = new THREE.MeshBasicMaterial({
            transparent: false,
            wireframe: false,
            // opacity: 0.9,
            // side: THREE.DoubleSide,
            // vertexColors: THREE.VertexColors,
            vertexColors: THREE.FaceColors,
        });

        overlayMesh = new THREE.Mesh(overlayGeometry, overlayMaterial);
        // overlayMesh.drawMode = THREE.TriangleStripDrawMode;
        scene.add(overlayMesh);

        // crossSectionData = null;
        // quickRender();
    }

    function meshPressureGraticuleContourLabel(crossSectionData, binaryScale, type){
        let glPositionsInfo = mcGeometry.crossSectionGraticuleLabelPositionsInfo(crossSectionData.coords, crossSectionData.data, crossSectionData.pressures, initScale);
        let positions = mcGeometry.crossSectionPressureLabelPositions(crossSectionData.coords, crossSectionData.data, crossSectionData.pressures, initScale);
        let contours = crossSectionContour(crossSectionData, binaryScale, type);
        let nLon = crossSectionData.coords.length;
        let nLat = crossSectionData.data.length / nLon;
        let crossSectionLabelPositionsInfo = mcGeometry.crossSectionContourLabelInfo(contours, nLon, nLat, crossSectionData.pressures, initScale);
        let textInfos = [];
        let ix = 0;

        crossSectionData.pressures.forEach(function(pressure){
            let textUnit = " hPa";
            if (pressure === 'surface') {
                textUnit = "";
            }
            textInfos.push({
                text: pressure + textUnit,
                position: positions[ix++],
                centerOffset: [-1.2, -0.5, 1.0],
                color: 0x5a5a5a,
            });
        });

        ix = 0;
        let lon = "";
        glPositionsInfo.positions.forEach(function(position){
            lon = glPositionsInfo.lons[ix++]
            textInfos.push({
                // text: lon === 180. ? lon + "" : lon > 0 ? lon + "E" : Math.abs(lon) + "W",
                text: lon + "",
                position: position,
                centerOffset: [-0.5, -1.7, 1.0],
                color: 0x5a5a5a,
            });
        });

        ix = 0;
        let value = 0;
        let maxValue = crossSectionLabelPositionsInfo.values[crossSectionLabelPositionsInfo.positions.length - 1];
        crossSectionLabelPositionsInfo.positions.forEach(function(position){
            value = crossSectionLabelPositionsInfo.values[ix++];
            // if (type !== "wind" && maxValue === value) { //invalid값에 대한 라벨처리(붉은색라벨)
            //     textInfos.push({
            //         text: "invalid",
            //         position: position,
            //         centerOffset: [-0.5, 0, 0],
            //         color: 0xFF0000,
            //     });
            // } else { //일반 값에 대한 라벨
            //     textInfos.push({
            //         text: value.toFixed(2),
            //         position: position,
            //         centerOffset: [-0.5, 0, 0],
            //         color: "wind" === type ? 0x6A6A97 : 0xBEF0FF,
            //     });
            // }
            textInfos.push({
                text: value.toFixed(2),
                position: position,
                centerOffset: [-0.5, 0, 0],
                color: "wind" === type ? 0x6A6A97 : 0xBEF0FF,
            });
        });
        pressureLabel = mcText(scene, 0);
        pressureLabel.render(textInfos, quickRender);
    }

    function meshCrossSectionContour(contours, material, nLon, nLat, pressures) {
        crossSectionContourGeometry = mcGeometry.crossSectionContourGeometry(contours, nLon, nLat, pressures, initScale);
        return new THREE.LineSegments(crossSectionContourGeometry, material);
    }

    function meshCrossSectionContourMaterial(crossSectionData, binaryScale, type){
        let nLon = crossSectionData.coords.length;
        let nLat = crossSectionData.data.length / nLon;

        crossSectionContourMaterial = new THREE.LineBasicMaterial({
            color: "wind" === type ? 0xCACAD7 : 0xBEF0F0,
            linewidth: 3,
            transparent: false,
        });
        let contours = crossSectionContour(crossSectionData, binaryScale, type);
        // if (type !== "wind") {
        //     //invalid값은 contour을 빨간색으로 하기위해 material을 별도로 만들어줌
        //     invalidCrossSectionContourMaterial = new THREE.LineBasicMaterial({
        //         color: 0xFF0000,
        //         linewidth: 3,
        //         transparent: false,
        //     });
        //     const invalidContour = [contours[contours.length - 1]];
        //     //invalidContour를 별도로 빼기 위한 filter
        //     contours = contours.filter((contour) => {
        //         return contour.value !== invalidContour[0].value;
        //     })
        //     //붉은색 material을 적용한 invalidMesh를 따로 추가해줌
        //     invalidCrossSectionContourMesh = meshCrossSectionContour(invalidContour, invalidCrossSectionContourMaterial, nLon, nLat, crossSectionData.pressures);
        //     scene.add(invalidCrossSectionContourMesh);
        // }
        //contours LineSegment Mesh
        crossSectionContourMesh = meshCrossSectionContour(contours, crossSectionContourMaterial, nLon, nLat, crossSectionData.pressures);
        scene.add(crossSectionContourMesh);

        quickRender();
    }

    function crossSectionContour(crossSectionData, binaryScale, type){
        let nLon = crossSectionData.coords.length;
        let nLat = crossSectionData.data.length / nLon;

        let contours = mcGeometry.crossSectionContour(nLon, nLat, crossSectionData.data.map(d => parseFloat((d[2] / binaryScale).toFixed(2))), type);

        return contours;
    }

    function init(){
        if(renderer !== undefined) return;

        let gl = checkWebGL(container);
        let left = -container.width / 2 - 20,
            right = container.width / 2,
            top = container.height / 2,
            bottom = -container.height / 2,
            near = 0.1,
            far = 30000;
        if (µ.isMobile()) {
            top = top * 0.2 + right * 0.2;
            bottom = bottom * 0.2 + left * 0.2;
        }
        renderer = new THREE.WebGLRenderer({canvas: container.node(), context: gl, antialias: false});
        camera = new THREE.OrthographicCamera(left, right, top, bottom, near, far);
        scene = new THREE.Scene();
        scene.add(camera);

        renderer.setAnimationLoop(animate);
    }

    function quickRender() {
        if(renderer === undefined || camera === undefined) return;

        camera.position.x = 0.;
        camera.position.y = 0.;
        camera.position.z = 16001.;

        camera.lookAt(scene.position);
        camera.updateProjectionMatrix();

        // renderer.setPixelRatio(pixelRatio());
        renderer.setSize(container.width, container.height);
        renderer.render(scene, camera);
    }

    function animate(){
        quickRender();
    }

    return {
        rendered: rendered,
        render: function render(crossSectionData, scale, binaryScale, type){
            if(!checkWebGL(container)) return false;
            if(!crossSectionData) {
                clearResource();
                return false;
            }

            let orientationchanged = configuration.get("orientationchanged"); // device orientation changed
            let changed = _.keys(configuration.changedAttributes());
            // if (_.intersection(changed, ["dataType"]).length > 0) {
            // 	overlayWorld.clear();
            // }

            if(orientationchanged){
                configuration.save({orientationchanged: false});
            }

            // initialize renderer, camera, scene, overlay
            init();

            clearMeshes();

            meshOverlayMaterial(crossSectionData, scale, binaryScale);
            meshPressureLineMaterial(crossSectionData);
            meshPressureGraticuleContourLabel(crossSectionData, binaryScale, type); //contour라벨
            meshCrossSectionContourMaterial(crossSectionData, binaryScale, type); //contour

            return true;
        },
        changeWebGlCanvas: function changeWebGlCanvas(){
            parentView = µ.view();
            container.width = parentView.width;
            container.height = parentView.height;
        },
        quickRender: quickRender,
        checkWebGL: checkWebGL,
        clearResource: clearResource,
    };

});